<div class="grid maintenance-mode-container full-height-grid mt-0">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pl-6 mt-6">
    <h2 class="maintenance-mode">
      {{ 'Maintenance.Title' | translate }}
    </h2>
    <br />
    <span class="large-paragraph maintenance-mode-message">
      {{ 'Maintenance.Description_one' | translate }}
      <br />
      <br />
      {{ 'Maintenance.Description_Two' | translate }}
      <br />
      <br />
      {{ 'Maintenance.Description_Three' | translate }}
    </span>
  </div>
</div>
